// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import { type LogKind, LogKindFromJSON, LogKindToJSON } from "../models/LogKind";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface LoggingRequest {
  /**
   *
   */
  kind: LogKind;
}

/**
 *
 */
export class LoggingApi extends runtime.BaseAPI {
  /**
   * Creates request options for logging without sending the request
   */
  async loggingRequestOpts(requestParameters: LoggingRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["kind"] == null) {
      throw new runtime.RequiredError(
        "kind",
        'Required parameter "kind" was null or undefined when calling logging().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["kind"] != null) {
      queryParameters["kind"] = requestParameters["kind"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " +
        btoa((this.configuration.username || "") + ":" + (this.configuration.password || ""));
    }

    let urlPath = `/logging`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * test logging
   */
  async loggingRaw(
    requestParameters: LoggingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.loggingRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * test logging
   */
  async logging(
    requestParameters: LoggingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.loggingRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
